export const forceHttps = () => {
    if (window.location.protocol != "https:") {
        location.href = location.href.replace("http://", "https://");
    }
};
